<template>
  <div class="reservation-container">
    <detail-dialog
      :visible="detailDialogVisible"
      :detail-data="currentDetail"
      :detail-id="currentDetail.id"
      @update:visible="(val) => (detailDialogVisible = val)"
    />
    <!-- 查询条件 -->
    <el-form :model="queryForm" ref="queryForm" inline>
      <el-form-item label="出库单号" prop="number">
        <el-input v-model="queryForm.number" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="预约日期" prop="dateRange">
        <el-date-picker
          v-model="queryForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>

      <el-form-item label="出库状态" prop="status">
        <el-select v-model="queryForm.status" placeholder="请选择">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="往来单位" prop="companyName">
        <el-input v-model="queryForm.companyName" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="粮食品种" prop="grainCategoryId">
        <el-select v-model="queryForm.grainCategoryId" placeholder="请选择">
          <el-option-group
            v-for="parent in grainTypes"
            :key="parent.id"
            :label="parent.name"
          >
            <el-option
              v-for="child in parent.childrenCategory"
              :key="child.id"
              :label="' ' + child.name"
              :value="child.id"
            />
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item label="粮食等级" prop="grainLevel">
        <el-select v-model="queryForm.grainLevel" placeholder="请选择">
          <el-option
            v-for="item in grainLevels"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="number" label="预约号" width="180" />
      <el-table-column prop="storageCompanyName" label="仓储公司" />
      <el-table-column prop="grainName" label="粮食品种" />
      <el-table-column prop="grainLevel" label="粮食等级" />
      <el-table-column
        prop="appointmentDispatchWeight"
        label="预约数量(KG)"
        align="center"
      />
      <el-table-column prop="createTime" label="提交时间" width="180" />
      <el-table-column
        prop="appointmentDispatchTime"
        label="预约出库时间"
        width="180"
      />
      <el-table-column prop="status" label="出库状态">
        <template #default="{ row }">
          <el-tag :type="statusTagMap[row.status]">
            {{ statusLabels[row.status] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template #default="{ row }">
          <el-button type="text" @click="handleView(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next,jumper"
      class="pagination-container"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import DetailDialog from "./DetailDialog.vue";
import {
  getGrainCategoryList,
  getStockOutOrderAppointmentList,
} from "@/api/warehousingService";
export default {
  name: "ReservationRecord",
  components: { DetailDialog },
  data() {
    return {
      // 查询表单
      queryForm: {
        number: "",
        dateRange: [],
        status: "",
        companyName: "",
        grainCategoryId: "",
        grainLevel: "",
      },
      // 新增弹窗相关数据
      detailDialogVisible: false,
      currentDetail: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,

      // 下拉选项
      statusOptions: [
        { value: 0, label: "待出库" },
        { value: 1, label: "出库中" },
        { value: 2, label: "出库完成" },
      ],
      grainTypes: [],
      grainLevels: [
        { value: 1, label: "一级" },
        { value: 2, label: "二级" },
        { value: 3, label: "三级" },
        { value: 4, label: "四级" },
        { value: 5, label: "五级" },
      ],

      // 表格数据
      tableData: [],

      // 状态映射
      statusTagMap: {
        0: "warning",
        1: "success",
        2: "info",
      },
      statusLabels: {
        0: "待出库",
        1: "出库中",
        2: "出库完成",
      },
    };
  },
  methods: {
    //获取粮食品种
    async getGrainCategoryList() {
      const res = await getGrainCategoryList();
      this.grainTypes = res.data;
    },
    handleSearch() {
      // 查询逻辑
      console.log("查询参数：", this.queryForm);
      this.currentPage = 1;
      this.loadTableData();
    },
    handleReset() {
      this.$refs.queryForm.resetFields();
    },
    handleView(row) {
      console.log("查看详情：", row);
      // 这里添加查看详情逻辑
      this.currentDetail.id = row.id;
      this.detailDialogVisible = true;
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadTableData();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadTableData();
    },
    // 加载表格数据
    async loadTableData() {
      this.loading = true;
      try {
        const params = {
          ...this.queryForm,
          startTime: this.queryForm.dateRange[0],
          endTime: this.queryForm.dateRange[1],
          current: this.currentPage,
          size: this.pageSize,
        };
        // 调用接口示例（需根据实际接口调整）
        const res = await getStockOutOrderAppointmentList(params);
        this.tableData = res.data.list;
        this.total = res.data.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getGrainCategoryList();
    this.loadTableData();
  },
};
</script>

<style scoped>
.reservation-container {
  padding: 20px;
}
.el-form {
  margin-bottom: 20px;
}
.el-form-item {
  margin-right: 20px;
}
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.el-pagination__jump {
  margin-left: 10px;
}
</style>
